import { OnboardingProvider } from '../context/OnboardingProvider';
import OnboardingShell from './OnboardingShell';

export default function OnboardingWrapper(): JSX.Element {
  return (
    <OnboardingProvider>
      <OnboardingShell />
    </OnboardingProvider>
  );
}
